export default __webpack_public_path__ + "static/media/head-olive.a968f86e.png";